import { HOME as idPrefix } from '../../../constants/translates';

const messages = {
  [`${idPrefix}.greeting`]: 'Ласкаво просимо на сайт з грою',
  [`${idPrefix}.formNameLabel`]: 'Введіть своє ім\'я',
  [`${idPrefix}.nextStepButton`]: 'Почати гру'
};

export default messages;
